import { colors } from '@10d/tend-ui-tokens/samolet';

import { IColor } from 'types';

export const TABLE_COLORS_DEFAULT: IColor = {
  TODO: {
    color: colors.gray0,
    bgcColor: colors.gray650,
    name: 'В работе',
  },
  NOT_ASSIGNED: {
    color: colors.gray0,
    bgcColor: colors.red600,
    name: 'Не назначено',
  },
  DONE: {
    color: colors.gray0,
    bgcColor: colors.green600,
    name: 'Выполнено',
  },
  CALL: {
    color: colors.gray0,
    bgcColor: colors.blue600,
    name: 'На проверке',
  },
  NOT_ACCEPTED: {
    color: colors.gray0,
    bgcColor: colors.red600,
    name: 'Не принята',
  },
  TESTING: {
    color: colors.gray0,
    bgcColor: colors.blue600,
    name: 'На проверке',
  },
  ACCEPTED: {
    color: colors.gray0,
    bgcColor: colors.green600,
    name: 'Принята',
  },
  ACCEPTED_WITH_ALBUM: {
    color: colors.gray0,
    bgcColor: colors.green600,
    name: 'Принята с дефектами',
  },
  NOT_READY: {
    color: colors.gray0,
    bgcColor: colors.gray650,
    name: 'Не готова к вызову',
  },
  IN_PROGRESS: {
    color: colors.gray0,
    bgcColor: colors.gold600,
    name: 'В ожидании',
  },
  NOT_APPROVED: {
    color: colors.gray0,
    bgcColor: colors.gold600,
    name: 'Не одобрено ОВП',
  },
  ACCEPTED_BY_PRIMARY_CONTRACTOR: {
    color: colors.gray0,
    bgcColor: '#13C2C2',
    name: 'Принята ПК',
  },
  // TODO
  // Занести эти цвета в samolet-ui
  DRAFT: {
    color: '#4A5368',
    bgcColor: '#EAEDF5',
    name: 'Черновик',
  },
};
